import styles from "./CardListScreen.module.css"

export const classes = {
  screenDivisionTop: [styles.ScreenDivisionTop],
  screenDivisionBottom: [styles.ScreenDivisionBottom]
}
